import CountryPhoneInputTemplate from 'src/components/etc/CountryPhoneInput/template'
import { FocusEvent, useLayoutEffect, useRef, useState } from 'react'
import en from 'react-phone-number-input/locale/en.json'
import { CountryCodeType } from 'src/types/phoneinput'
import { getCountries, getCountryCallingCode } from 'react-phone-number-input'
import { setTempCountryCode } from 'src/store/Reducer/socket/homePageSlice'
import { setModalItems } from 'src/store/Reducer/common/modalSlice'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'
import { addCountryList, excludedCountryCodes } from 'src/constants/etc'
import useMouseDownElement from 'src/hooks/useMouseDownElement.hook'

export type CountryPhoneInputType = {
  CountrySelectHandler: (str: string, country: CountryCodeType) => void
  onBlurPhoneInput: (e: FocusEvent) => void
  state: { tempCountryInfo: string }
  CountryList: CountryCodeType[]
  customCountryLabel: (country: CountryCodeType) => string
}
const CountryPhoneInput = () => {
  const { t } = useTranslation()
  const inputRef = useRef<HTMLInputElement>(null)
  const dispatch = useAppDispatch()
  const { TempValue, CountryCode, GPNumber } = useAppSelector((state: RootState) => state.HomePage)
  const [tempCountryInfo, setTempCountryInfo] = useState('')
  const { className: targetClassName } = useMouseDownElement()
  const CountrySelectHandler = (str: string, country: CountryCodeType) => {
    setTempCountryInfo(str)
    dispatch(setTempCountryCode({ country: country, num: getCountryCallingCode(country) }))
    inputRef.current && inputRef.current.focus()
  }

  const onBlurPhoneInput = (e: FocusEvent) => {
    const target = e.relatedTarget?.className || targetClassName || ""

    //blur 된곳이 Save 버튼이 아닐 때
    switch (true) {
      //기존의 값과 변경이 일어난 경우
      case !target?.includes('country') && TempValue.CountryCode.num !== CountryCode:
      case !target?.includes('country') && TempValue.GPNumber !== GPNumber:
        dispatch(
          setModalItems({
            type: 'alert',
            text: `${t('MODAL.HOME_CONTACT_ERROR')}`,
            confirmFunc: () => {
              inputRef.current && inputRef.current.focus()
            },
          }),
        )
        break
      default:
        break
    }
  }
  const customCountryLabel = (country: CountryCodeType) => {
    switch (country) {
      case 'US':
        return `${en['US']} / ${en['CA']} (+1)`
      case 'RU':
        return `${en['RU']} / ${en['KZ']} (+7)`
      case 'YT':
        return `${en['YT']} / ${en['RE']} (+262)`
      case 'GP':
        return `${en['GP']} / ${en['BL']} (+590)`
      default:
        return `${en[country]} (+${getCountryCallingCode(country)})`
    }
  }

  // 국가번호 중복 리스트 커스텀(두 나라 이상 표시)
  useLayoutEffect(() => {
    setTempCountryInfo(customCountryLabel(TempValue?.CountryCode?.country as CountryCodeType))
  }, [TempValue?.CountryCode?.country])

  const CountryList = [
    ...getCountries().filter((w: any) => !excludedCountryCodes.includes(getCountryCallingCode(w))),
    ...addCountryList,
  ]?.sort() as CountryCodeType[]

  const data: CountryPhoneInputType = {
    CountrySelectHandler,
    onBlurPhoneInput,
    CountryList,
    customCountryLabel,
    state: {
      tempCountryInfo,
    },
  }
  return <CountryPhoneInputTemplate data={data} ref={inputRef} />
}
export default CountryPhoneInput
